<template>
    <div
        id="sidebar-tokens-container"
        :class="[
          'w-full h-10 rounded text-sm',
          'flex items-center',
          collapsed ? 'justify-center' : 'justify-between',
        ]"
        :style="{
          padding: '0 11px',
          backgroundColor: isInLimit
            ? 'rgba(243, 137, 79, 0.15)'
            : 'transparent',
        }"
      >
        <div class="flex items-center" v-if="!collapsed">
          <div class="won-blue">Tokens Left</div>

          <Question
            v-if="isInLimit"
            class="ml-1 cursor-pointer"
            v-tooltip="{
              content: tooltipContent,
              placement: 'top',
              html: true,
            }"
          />
        </div>

        <div class="flex items-center">
          <div class="won-modal-paragraph-color">
            {{ tokens }}
          </div>

          <won-coin class="w-4 h-4 ml-1" />
        </div>
      </div>
</template>

<script>

import { storeToRefs } from 'pinia'
import { ref } from 'vue'

import { useTokens } from '../../store/token.store'

import Question from '../../icons/info-question.vue'
import WonCoin from '../../icons/won-coin.vue'

export default {
    props: {
        collapsed: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        Question,
        WonCoin,
    },
    setup() {
        const tokensStore = useTokens()
        tokensStore.initTokens()

        const { tokens } = storeToRefs(tokensStore)

        const tooltipContent = ref(`<div style="max-width: 142px">Looks like you’re low on tokens! To keep generating bullet points, be sure to buy more.</div>`)

        return {
            tokens,
            tooltipContent
        }
    },
    computed: {
        isInLimit() {
            return this.tokens <= 3
        },
    },

}
</script>